/*
 * @Author: 陈朝晖
 * @Date: 2022-07-05 17:56:30
 * @LastEditTime: 2024-02-20 11:36:04
 * @Description: 前往付款混入 提供根据订单信息前往支付的能力
 *
 * **这个组件认为 moneyFormat 这个filter已经有了定义
 */
import { Loading } from "element-ui";
import { STORAGE_KEYS } from "../../../dictionary/storeageKeys";
export default {
  methods: {
    /**
     * 旧版去支付 提供给1.0选手
     * @param {*} OrderNo 订单号
     */
    gotoPay(OrderNo) {
      this.$router.push({
        path: "/collectMoney/payIndex",
        query: {
          OrderNo,
        },
      });
    },

    /**
     * @description 新版去支付
     * @param {*} OrderNo 订单号
     * @param {*} amount 订单价格
     * @param {*} OrderSign 标识 1 现货 2合约
     */
    gotoPay2(OrderNo, amount, OrderSign = "1") {
      if (OrderSign === "1") {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据加载中",
          background: "rgba(0,0,0,.6)",
        });

        var Customer = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.cartCusomer)) || {};
        if (Customer.Id) {
          this.bindCusomerAndTrunToQrcode(OrderNo, amount, Customer);
        } else {
          loadingInstance.close();
          this.turnToQrcode(OrderNo, amount, OrderSign);
        }
      } else {
        // 合约单直接转
        this.turnToQrcode(OrderNo, amount, OrderSign);
      }
    },
    /**
     * @method bindCusomerAndTrunToQrcode
     * @description 指定用户并转向订单二维码
     */
    bindCusomerAndTrunToQrcode(OrderNo, amount, Customer) {
      this.$ajax
        .post("/api/Order/PreOrderSave", {
          CustomerId: Customer.Id || "",
          CustomerName: Customer.Name || "",
          OrderId: OrderNo,
          // SendOrderType: this.deliveryType,
        })
        .then((res) => {
          loadingInstance.close();
          // 这里一定是普通单
          this.turnToQrcode(OrderNo, amount);
        });
    },
    /**
     * @method turnToQrcode
     * @description 转向订单二维码
     */
    turnToQrcode(OrderNo, amount, OrderSign = "1") {
      const path =
        OrderSign === "2" ? "/processingCollectMoney/payQrcode" : "/collectMoney/payQrcode";
      setTimeout(() => {
        this.$router.replace({
          path,
          query: {
            OrderNo,

            channel: OrderSign === "2" ? "0" : "1",
            amount: this.$options.filters.moneyFormat(amount),
          },
        });
      }, 200);
    },
  },
};
